"use strict";

angular.module("customer")
.directive("catalogEntryGrid", function() {
    return {
        restrict: "E",
        controllerAs: "stockCatalogEntryGridCtrl",
        templateUrl: require("./catalog-entry-grid.directive.html"),
        scope: true,
        bindToController: {
            catalogEntry: "=",
            vendor: "=",
            resetFunction: "&"
        },
        controller: function($scope, $rootScope, $controller) {
            angular.extend(this, $controller("AbstractStockCatalogEntryController", {_this: this, $scope: $scope}));

        }
    };
});



//////////////////
// WEBPACK FOOTER
// ./customer/sections/stock/catalog-entry/catalog-entry-grid.directive.js
// module id = 930
// module chunks = 0